function PaymentHeader() {
    return (
      <div className='header1'>
        {/* <img src={img} alt="menu" className='menu-img'/> */}
        <div style={{fontFamily:"Oswald,sans-serif",fontSize:"2rem"}}>Payment Insights</div>
      </div>
    );
  }
  
  export default PaymentHeader;